import React, { PureComponent } from 'react';
import './userDropdown.less';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import * as R from 'ramda';
import { withActions } from 'actionware';
import { authLogout } from '../login/loginActions';
import { getInitials } from '../../common/helpers';
import { push } from 'connected-react-router';
import Button from '../../components/button/button';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { matchPath, withRouter } from 'react-router-dom';
import { Icon } from 'antd';

@withRouter
@connect(
  ({ session, localize }) => ({
    translate: getTranslate(localize),
    userId: R.path(['user', 'id'], session),
    loggedIn: !!(session && session.authenticated && session.user),
    userName: R.pathOr('', ['user', 'user', 'name'], session),
    role: R.path(['user', 'user', 'role'], session)
  }),
  dispatch => {
    return bindActionCreators({ push }, dispatch);
  }
)
@withActions({
  authLogout
})
class UserDropdown extends PureComponent {
  state = {
    unfolded: false
  };

  toggleUserPanel = () => {
    this.setState({
      unfolded: !this.state.unfolded
    });
  };

  onClickProfile = () => {
    this.setState({
      unfolded: false
    });
    this.props.push('/profile');
  };

  onClickLogout = () => {
    this.setState({
      unfolded: false
    });
    this.props.authLogout();
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside = event => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      this.state.unfolded
    ) {
      this.setState({
        unfolded: false
      });
    }
  };

  userPanel(userName, nameInitials, role) {
    const { translate } = this.props;
    return (
      <div className={'user-panel'}>
        <div className={'name-badge'}>{nameInitials}</div>
        <div className={'user-name'}>{userName}</div>
        {/* <div className={'user-info'}>
          {translate('nav.lenderSince', { date: 'January 2017' })}
        </div> */}
       {role === "LENDER" && <Button onClick={this.onClickProfile}>
          {this.props.translate('nav.viewProfile')}
        </Button>}
        <div className={'footer-links'}>
          {/* <Link to={'/about'} onClick={this.toggleUserPanel}>{translate('nav.about')}</Link>
        <Link to={'/contact'} onClick={this.toggleUserPanel}>{translate('nav.contact')}</Link> */}
          <a onClick={this.onClickLogout}>{translate('nav.signout')}</a>
        </div>
      </div>
    );
  }

  render() {
    const { userName, role } = this.props;
    const nameInitials = getInitials(userName);

    return (
      <div
        ref={this.setWrapperRef}
        className={classnames('user-dropdown', {
          unfolded: this.state.unfolded,
          active:
            this.state.unfolded ||
            matchPath(this.props.location.pathname, { path: '/profile' })
        })}
      >
        <div
          className={'user-dropdown__container'}
          onClick={this.toggleUserPanel}
        >
          <div className={'name-badge'}>{nameInitials}</div>
          <div className={'user-name'}>{userName}</div>
          <Icon type={this.state.unfolded ? "down" : "up"} />
        </div>
        {this.userPanel(userName, nameInitials, role)}
      </div>
    );
  }
}

export default UserDropdown;
